import {RouteConfig} from 'vue-router';

export const utentiRoutes: RouteConfig = {
    path: 'utenti',
    component: () => import('@/views/private/utenti/UtentiView.vue'),
    children: [
        {
            path: '',
            name: 'utenti',
            component: () => import('@/views/private/utenti/index/UtentiIndex.vue'),
        },
    ],
    meta: {
        roles: ['ROLE_ADMIN']
    },
};
